import { FC } from "react"
import { Link } from "react-router-dom"

/* ================= TYPES ================= */

type RightItemData = {
    label: string
    icon: string
}

type RightItemProps = {
    label: string
    icon: string
    href: string
}

/* ================= COMPONENT CON ================= */

const RightItem: FC<RightItemProps> = ({ label, icon, href }) => {
    return (
        <Link
            className="styles_RightPanelItem__DPU5m"
            to={href}
            style={{ textDecoration: 'none', color: 'inherit' }}
        >
            <div className="styles_RightPanelItemContent___OTW6">
                <div className="styles_RightPanelIcon__s_LEU">
                    <span
                        style={{
                            boxSizing: "border-box",
                            display: "inline-block",
                            overflow: "hidden",
                            width: "initial",
                            height: "initial",
                            background: "none",
                            opacity: 1,
                            border: 0,
                            margin: 0,
                            padding: 0,
                            position: "relative",
                            maxWidth: "100%",
                        }}
                    >
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "block",
                                width: "initial",
                                height: "initial",
                                background: "none",
                                opacity: 1,
                                border: 0,
                                margin: 0,
                                padding: 0,
                                maxWidth: "100%",
                            }}
                        >
                            <img
                                alt=""
                                aria-hidden="true"
                                src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20width='60'%20height='60'/%3e"
                                style={{
                                    display: "block",
                                    maxWidth: "100%",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                }}
                            />
                        </span>

                        {
                            icon && (
                                <img
                                    alt={label}
                                    src={icon}
                                    decoding="async"
                                    data-nimg="intrinsic"
                                    style={{
                                        position: "absolute",
                                        inset: 0,
                                        boxSizing: "border-box",
                                        padding: 0,
                                        border: "none",
                                        margin: "auto",
                                        display: "block",
                                        width: 0,
                                        height: 0,
                                        minWidth: "100%",
                                        maxWidth: "100%",
                                        minHeight: "100%",
                                        maxHeight: "100%",
                                    }}
                                />
                            )
                        }
                    </span>
                </div>

                <span className="styles_RightPanelLabel__NWtS9">
                    {label}
                </span>
            </div>
        </Link>
    )
}

/* ================= COMPONENT CHA ================= */

const RightPanel: FC<{ items: any[]; isGroup?: boolean }> = ({ items, isGroup }) => {
    return (
        <div className="styles_RightPanel__f_KDj">
            <div className="styles_RightPaneCover__V18Ol">
                {items?.map(item => (
                    <RightItem
                        key={item.id || item.label}
                        label={item.name || item.label}
                        icon={item.avatar || item.icon}
                        href={isGroup 
                            ? `/products?group=${item.id}` 
                            : `/products?category=${item.id}`
                        }
                    />
                ))}
            </div>
        </div>
    )
}

export default RightPanel
